export const PRODUCT_CATEGORIES = [
  'Haircare',
  'Skincare',
  'Makeup',
  'Nails',
  'Fragrance',
  'Tools',
  'Other',
];
